import React from "react"
import { Link } from "gatsby"
import Children from "react-children-utilities"

export const TermClusterBlockquote = ({ content }) => {
  const cluster_ul = Children.filter(content, ({ type }) => type === "ul")[0]

  const cluster_list = Children.filter(
    cluster_ul.props.children,
    ({ type }) => type === "li"
  )

  const cluster_links = cluster_list.map(
    (list_item) =>
      Children.filter(list_item.props.children, ({ type }) => type === "a")[0]
  )

  return (
    <div
      className="has-text-mitternachtsblau my-4"
      style={{ borderColor: "#034055" }}
    >
      <div className="buttons is-centered">
        {cluster_links.map(({ props: { children, href } }, index) => {
          return (
            <Link
              key={children + index}
              to={href}
              className="button is-rounded is-mitternachtsblau is-outlined"
            >
              {children[0]}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
